import React from "react";
import "./SideNav.css";
import { Image } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { Navigation } from 'CommonComponent';
import { useSelector } from 'react-redux';

const SideNav = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();

  const session = useSelector((state) => state.session);

  return (
    <div className={`sideNav ${isOpen ? "open" : "closed"}`}>
      {/* Header: Logo + Toggle Button */}
      <div className="d-flex justify-content-between align-items-center mb-5">
        <Image
          src={
            isOpen
              ? "/assets/images/NX-logo.svg"
              : "/assets/images/nx.svg"
          }
          alt="Logo"
          className="sidebar-logo"
        />
        <Image
          src={
            isOpen
              ? "/assets/images/menu-collapse.svg"
              : "/assets/images/menu-expand.svg"
          }
          alt="Toggle Sidebar"
          onClick={toggleSidebar}
          style={{ cursor: "pointer" }}
        />
      </div>

      {(session.nested_menus) ?
        <Navigation
          component="div"
          pages={session.nested_menus}
          isMenuCollapse={isOpen}
        />
        : ''}

    </div>
  );
};

export default SideNav;
